// extracted by mini-css-extract-plugin
export default {"icon":"Achievements_icon__mkFkg","title":"Achievements_title__KLTiD","subtitle":"Achievements_subtitle__Za7rB","fadeInBg":"Achievements_fadeInBg__eNMDz"};